import * as angular from 'angular';

"use strict";
angular.module('TwoFactorAuthenticationModule', []);

export default 'TwoFactorAuthenticationModule';
